<div class="ca">
  <div class="ca-contenedor">

    <!-- Encabezado -->
    <header class="ca-encabezado">
      <div class="ca-titulo">
        <div class="ca-logo" aria-hidden="true">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3v11"></path><path d="m7.5 9.5 4.5 4.5 4.5-4.5"></path><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"></path></svg>
        </div>
        <div>
          <h1>Conciliación de abonos</h1>
          <p>
            Lo que entró a cada cuenta de Aguacate y a quién se asignó
            <ng-container *ngIf="actualizado"> · actualizado {{ horaActualizado() }}</ng-container>
          </p>
        </div>
      </div>
      <div class="ca-acciones">
        <div class="ca-seg" role="group" aria-label="Período">
          <button type="button" [class.on]="periodo === 'hoy'" [attr.aria-pressed]="periodo === 'hoy'" (click)="elegirPeriodo('hoy')">Hoy</button>
          <button type="button" [class.on]="periodo === '7'" [attr.aria-pressed]="periodo === '7'" (click)="elegirPeriodo('7')">7 días</button>
          <button type="button" [class.on]="periodo === '30'" [attr.aria-pressed]="periodo === '30'" (click)="elegirPeriodo('30')">30 días</button>
          <button type="button" [class.on]="periodo === 'rango'" [attr.aria-pressed]="periodo === 'rango'" (click)="elegirPeriodo('rango')">Rango…</button>
        </div>
        <div class="ca-rango" *ngIf="periodo === 'rango'">
          <label for="ca-desde" class="ca-oculto">Desde</label>
          <input id="ca-desde" type="date" class="ca-campo" [(ngModel)]="desde" [max]="hasta" (change)="cambiarRango()">
          <span aria-hidden="true">–</span>
          <label for="ca-hasta" class="ca-oculto">Hasta</label>
          <input id="ca-hasta" type="date" class="ca-campo" [(ngModel)]="hasta" [min]="desde" (change)="cambiarRango()">
        </div>
        <button type="button" class="ca-btn ca-btn-o" (click)="refrescar()" aria-label="Actualizar">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21 12a9 9 0 1 1-3-6.7L21 8"></path><path d="M21 3v5h-5"></path></svg>
        </button>
        <button type="button" class="ca-btn ca-btn-o" (click)="exportar()" [disabled]="descargando || !lista?.total">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 3v12"></path><path d="m7 10 5 5 5-5"></path><path d="M5 21h14"></path></svg>
          {{ descargando ? 'Generando…' : 'Exportar Excel' }}
        </button>
      </div>
    </header>

    <!-- Pestañas -->
    <nav class="ca-paises" aria-label="Moneda">
      <button type="button" *ngFor="let p of paises" class="ca-pais" [class.ca-pais-on]="pais === p.clave" (click)="elegirPais(p.clave)" [attr.aria-pressed]="pais === p.clave">
        <span class="ca-cod">{{ p.codigo }}</span>
        <span>{{ p.nombre }}</span>
        <span class="ca-pend" *ngIf="pendientesPorPais[p.clave]">{{ pendientesPorPais[p.clave] }} por resolver</span>
      </button>
    </nav>

    <div class="ca-error" *ngIf="error" role="alert">{{ error }}</div>
    <div class="ca-aviso" *ngIf="recortado" role="status">
      La pantalla muestra como máximo 62 días: se ve {{ periodoMostrado }}.
    </div>

    <!-- Reparto + por resolver -->
    <section class="ca-top">
      <div class="ca-card ca-hero">
        <div class="ca-hero-cab">
          <div>
            <div class="ca-etq">{{ etiquetaPeriodo }}</div>
            <div class="ca-total">{{ formatoMonto(montoClientes) }}</div>
            <div class="ca-sub">de clientes · {{ cantidadCuentas }} {{ cantidadCuentas === 1 ? 'cuenta' : 'cuentas' }}</div>
            <div class="ca-sub" *ngIf="resumen?.entradas?.montoPropio">
              + {{ formatoMonto(resumen?.entradas?.montoPropio) }} en cuentas propias (Fábrica Rosa, traspasos entre cuentas de Aguacate, cargas del cajero).
            </div>
            <div class="ca-sub" *ngIf="resumen?.entradas?.montoSinReclamar">
              + {{ formatoMonto(resumen?.entradas?.montoSinReclamar) }} sin reclamar en Binance, en su mayoría tesorería.
            </div>
            <div class="ca-sub" *ngIf="resumen?.ajustes?.cantidad">
              + {{ formatoMonto(resumen?.ajustes?.monto) }} en {{ resumen?.ajustes?.cantidad }} {{ resumen?.ajustes?.cantidad === 1 ? 'ajuste' : 'ajustes' }} (abonos manuales y conversiones), que no es plata que entró.
            </div>
          </div>
          <div class="ca-pct">
            <div class="ca-etq">Acreditado</div>
            <div class="ca-pct-num">{{ pctAsignado }}</div>
          </div>
        </div>
        <div class="ca-etq">Reparto de todas las filas del período, ajustes incluidos</div>
        <div class="ca-barra" role="img" aria-label="Reparto del dinero por estado">
          <div *ngFor="let s of segmentos" [style.flex]="s.peso + ' 1 0'" [style.background]="estados[s.estado].color" [title]="estados[s.estado].etiqueta + ': ' + formatoMonto(s.monto)"></div>
          <div *ngIf="!segmentos.length" class="ca-barra-vacia"></div>
        </div>
        <div class="ca-leyenda">
          <button type="button" *ngFor="let e of leyenda" class="ca-ley" (click)="elegirEstado(e.estado)" [class.ca-ley-on]="estado === e.estado" [attr.aria-pressed]="estado === e.estado">
            <span class="ca-dot" [style.background]="estados[e.estado].color"></span>
            <span>
              <span class="ca-ley-etq">{{ estados[e.estado].etiqueta }}</span>
              <span class="ca-ley-monto">{{ formatoMonto(e.monto) }}</span>
              <span class="ca-ley-n">{{ e.cantidad }} {{ e.cantidad === 1 ? 'entrada' : 'entradas' }}</span>
            </span>
          </button>
        </div>
        <div class="ca-cargando" *ngIf="cargandoResumen && !resumen">Cargando resumen…</div>
      </div>

      <div class="ca-card ca-resolver">
        <div class="ca-resolver-cab">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#9a3412" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3 2"></path></svg>
          <h2>Por resolver</h2>
        </div>
        <div class="ca-resolver-total">{{ formatoMonto(resumen?.porResolver?.monto) }}</div>
        <div class="ca-sub">{{ resumen?.porResolver?.cantidad || 0 }} entradas</div>
        <div class="ca-resolver-lista">
          <button type="button" *ngFor="let p of pendientes" (click)="elegirEstado(p.estado)">
            <span class="ca-badge" [ngClass]="estados[p.estado].clase">{{ estados[p.estado].etiqueta }}</span>
            <span class="ca-resolver-der">
              <b>{{ formatoMonto(p.monto) }}</b>
              <span>{{ p.cantidad }}</span>
              <span aria-hidden="true" class="ca-flecha">›</span>
            </span>
          </button>
          <p class="ca-vacio-chico" *ngIf="resumen && !pendientes.length">Nada pendiente en el período.</p>
        </div>
      </div>
    </section>

    <!-- Cuentas -->
    <section class="ca-cuentas" *ngIf="cuentasDelFiltro.length">
      <button type="button" class="ca-card ca-cuenta" *ngFor="let c of cuentasDelFiltro" (click)="elegirCuenta(c.cuenta)" [class.ca-cuenta-on]="cuenta === c.cuenta" [attr.aria-pressed]="cuenta === c.cuenta">
        <span class="ca-cuenta-cab">
          <span class="ca-cuenta-id">
            <span class="ca-av ca-av-cuadrado">{{ iniciales(c.cuentaNombre) }}</span>
            <span><b>{{ c.cuentaNombre }}</b><small>{{ c.cuentaDetalle }}</small></span>
          </span>
          <span class="ca-cuenta-pct" *ngIf="!c.propia && c.monto">{{ ((c.montoOk / c.monto) * 100) | number:'1.0-0' }} % acreditado</span>
        </span>
        <span class="ca-cuenta-total">{{ formatoMonto(c.monto) }}</span>
        <span class="ca-barra ca-barra-fina" role="img" aria-label="Acreditado frente a pendiente">
          <span *ngFor="let t of tramosCuenta(c)" [style.flex]="t.valor + ' 1 0'" [style.background]="t.color"></span>
        </span>
        <span class="ca-cuenta-pie">
          <span>{{ c.cantidad }} {{ c.cantidad === 1 ? 'entrada' : 'entradas' }}<ng-container *ngIf="c.ajuste"> · ajuste</ng-container></span>
          <span class="ca-cuenta-aire" *ngIf="c.propia">Cuenta propia</span>
          <span class="ca-cuenta-aire" *ngIf="!c.propia && c.montoPendiente">{{ formatoMonto(c.montoPendiente) }} por resolver</span>
          <span class="ca-cuenta-ok" *ngIf="!c.propia && !c.montoPendiente">Todo resuelto</span>
        </span>
      </button>
    </section>

    <!-- Filtros -->
    <section class="ca-card ca-filtros">
      <div class="ca-filtros-fila">
        <div class="ca-buscar">
          <label for="ca-buscar" class="ca-oculto">Buscar</label>
          <input id="ca-buscar" class="ca-campo" [(ngModel)]="buscar" (ngModelChange)="alEscribir()" [placeholder]="pais === 'VE' ? 'Buscar por documento, teléfono, nombre, referencia o cliente' : pais === 'USDT' ? 'Buscar por txId, dirección o cliente' : 'Buscar por RUT, nombre, referencia o cliente'" maxlength="120">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#6b7280" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="7"></circle><path d="m20 20-3.5-3.5"></path></svg>
        </div>
        <div class="ca-select">
          <label for="ca-cuenta" class="ca-oculto">Cuenta</label>
          <select id="ca-cuenta" class="ca-campo" [(ngModel)]="cuenta" (change)="cambiarCuenta()">
            <option value="">Todas las cuentas</option>
            <option *ngFor="let c of cuentasDelFiltro" [value]="c.cuenta">{{ c.cuentaNombre }}</option>
          </select>
        </div>
      </div>
      <div class="ca-chips">
        <button type="button" *ngFor="let ch of chips" class="ca-chip" [class.ca-chip-on]="estado === ch.estado" [attr.aria-pressed]="estado === ch.estado" (click)="elegirEstado(ch.estado)">
          {{ ch.etiqueta }} <span>{{ ch.cantidad }}</span>
        </button>
      </div>
    </section>

    <!-- Lista + detalle -->
    <section class="ca-zona">
      <div class="ca-card ca-lista">
        <div class="ca-cargando-barra" *ngIf="cargandoLista"></div>

        <div class="ca-tabla-caja">
          <table>
            <thead>
              <tr>
                <th>Hora</th>
                <th>Depositó</th>
                <th>Cuenta</th>
                <th>Llegó por</th>
                <th class="ca-der">Monto</th>
                <th>Estado</th>
                <th>Asignado a</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let item of items; trackBy: trackItem">
                <tr class="ca-dia" *ngIf="item.tipo === 'dia'"><td colspan="7">{{ item.etiqueta }}</td></tr>
                <tr *ngIf="item.tipo === 'fila'" class="ca-fila" [class.ca-fila-on]="seleccion === item.clave" (click)="abrir(item.fila)" tabindex="0" role="button" [attr.aria-pressed]="seleccion === item.clave" [attr.aria-label]="'Ver detalle de ' + formatoMonto(item.fila.monto, item.fila.moneda) + ' de ' + (item.fila.nombre || 'sin nombre')" (keydown)="teclaFila($event, item.fila)">
                  <td class="ca-hora">{{ hora(item.fila.fecha) }}</td>
                  <td>
                    <div class="ca-fuerte ca-recorta">{{ item.fila.nombre || '—' }}</div>
                    <div class="ca-tenue ca-recorta">
                      <ng-container *ngIf="item.fila.documento">{{ item.fila.documento }} · </ng-container>Ref {{ item.fila.referencia || '—' }}
                    </div>
                  </td>
                  <td>
                    <div class="ca-fuerte ca-nowrap">{{ item.fila.cuentaNombre }}</div>
                    <div class="ca-tenue ca-nowrap">{{ item.fila.cuentaDetalle }}</div>
                  </td>
                  <td><span class="ca-fuente" *ngFor="let fu of item.fila.fuentes">{{ fu }}</span></td>
                  <td class="ca-der ca-monto">{{ formatoMonto(item.fila.monto, item.fila.moneda) }}</td>
                  <td>
                    <span class="ca-badge" [ngClass]="estados[item.fila.estado].clase">{{ estados[item.fila.estado].etiqueta }}</span>
                    <div class="ca-tenue" *ngIf="item.fila.historica">histórico</div>
                    <div class="ca-tenue" *ngIf="item.fila.ajuste">ajuste</div>
                  </td>
                  <td>
                    <div class="ca-asignado" *ngIf="item.fila.cliente as c">
                      <div class="ca-asignado-quien">
                        <span class="ca-av">{{ iniciales(c.nombre) }}</span>
                        <span class="ca-asignado-txt">
                          <span class="ca-fuerte ca-recorta">{{ c.nombre }}</span>
                          <span class="ca-tenue ca-recorta">ID {{ c.usuarioId }} · {{ c.como }}</span>
                        </span>
                      </div>
                      <button type="button" class="ca-btn ca-btn-o" (click)="verMovimientos(item.fila, $event)" [disabled]="!c.email" [title]="c.email ? 'Ver movimientos de ' + c.nombre : 'El cliente no tiene correo'">
                        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 6h16M4 12h16M4 18h10"></path></svg>
                        Movimientos
                      </button>
                    </div>
                    <div class="ca-asignado" *ngIf="!item.fila.cliente">
                      <div class="ca-asignado-quien">
                        <span class="ca-av ca-av-vacio">?</span>
                        <span class="ca-sinasignar">{{ item.fila.estado === 'DIS' ? 'Cuenta propia' : 'Sin asignar' }}</span>
                      </div>
                      <button type="button" class="ca-btn ca-btn-p" *ngIf="accion(item.fila) as a" (click)="irA(a.ruta, $event)">{{ a.etiqueta }}</button>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <!-- Celular: tarjetas -->
        <div class="ca-tarjetas">
          <ng-container *ngFor="let item of items; trackBy: trackItem">
            <div class="ca-tarjeta-dia" *ngIf="item.tipo === 'dia'">{{ item.etiqueta }}</div>
            <div *ngIf="item.tipo === 'fila'" class="ca-tarjeta" [class.ca-fila-on]="seleccion === item.clave">
              <button type="button" class="ca-tarjeta-cuerpo" (click)="abrir(item.fila)">
                <span class="ca-tarjeta-cab">
                  <span>
                    <span class="ca-tarjeta-monto">{{ formatoMonto(item.fila.monto, item.fila.moneda) }}</span>
                    <span class="ca-tenue">{{ hora(item.fila.fecha) }} · {{ item.fila.cuentaNombre }}</span>
                  </span>
                  <span class="ca-badge" [ngClass]="estados[item.fila.estado].clase">{{ estados[item.fila.estado].etiqueta }}</span>
                </span>
                <span class="ca-fuerte ca-recorta">{{ item.fila.nombre || '—' }}</span>
                <span class="ca-tenue ca-recorta"><ng-container *ngIf="item.fila.documento">{{ item.fila.documento }} · </ng-container>Ref {{ item.fila.referencia || '—' }}</span>
              </button>
              <div class="ca-tarjeta-pie">
                <span class="ca-asignado-quien" *ngIf="item.fila.cliente as c">
                  <span class="ca-av">{{ iniciales(c.nombre) }}</span>
                  <span class="ca-fuerte ca-recorta">{{ c.nombre }} · ID {{ c.usuarioId }}</span>
                </span>
                <span class="ca-asignado-quien" *ngIf="!item.fila.cliente">
                  <span class="ca-av ca-av-vacio">?</span>
                  <span class="ca-sinasignar">{{ item.fila.estado === 'DIS' ? 'Cuenta propia' : 'Sin asignar' }}</span>
                </span>
                <button type="button" class="ca-btn ca-btn-o" *ngIf="item.fila.cliente?.email" (click)="verMovimientos(item.fila, $event)">Movimientos</button>
                <button type="button" class="ca-btn ca-btn-p" *ngIf="!item.fila.cliente && accion(item.fila) as a" (click)="irA(a.ruta, $event)">{{ a.etiqueta }}</button>
              </div>
            </div>
          </ng-container>
        </div>

        <div class="ca-vacio" *ngIf="!cargandoLista && lista && !lista.total">
          <b>No hay entradas con estos filtros.</b>
          <span>Prueba con otro período o quita un filtro.</span>
        </div>

        <!-- Paginado -->
        <div class="ca-paginado" *ngIf="lista?.total">
          <div class="ca-paginado-info">
            <span>Mostrando <b>{{ desdeFila }}–{{ hastaFila }}</b> de <b>{{ lista?.total }}</b></span>
            <label for="ca-limite">Filas</label>
            <select id="ca-limite" class="ca-campo ca-campo-chico" [(ngModel)]="limite" (change)="cambiarLimite()">
              <option *ngFor="let o of opcionesLimite" [ngValue]="o">{{ o }}</option>
            </select>
          </div>
          <div class="ca-paginas">
            <button type="button" class="ca-pag" aria-label="Página anterior" [disabled]="(lista?.pagina || 1) <= 1" (click)="irAPagina((lista?.pagina || 1) - 1)">‹</button>
            <ng-container *ngFor="let p of paginas">
              <span class="ca-pag-salto" *ngIf="p === '…'">…</span>
              <button type="button" *ngIf="p !== '…'" class="ca-pag" [class.ca-pag-on]="p === lista?.pagina" [attr.aria-current]="p === lista?.pagina ? 'page' : null" (click)="irAPagina(+p)">{{ p }}</button>
            </ng-container>
            <button type="button" class="ca-pag" aria-label="Página siguiente" [disabled]="(lista?.pagina || 1) >= totalPaginas" (click)="irAPagina((lista?.pagina || 1) + 1)">›</button>
          </div>
        </div>
      </div>

      <!-- Detalle -->
      <aside class="ca-card ca-detalle" #panelDetalle *ngIf="detalle || cargandoDetalle" aria-live="polite">
        <div class="ca-cargando" *ngIf="cargandoDetalle && !detalle">Cargando detalle…</div>
        <ng-container *ngIf="detalle as d">
          <div class="ca-detalle-cab">
            <div>
              <div class="ca-detalle-etq">Detalle de la entrada</div>
              <div class="ca-detalle-monto">{{ formatoMonto(d.fila.monto, d.fila.moneda) }}</div>
              <div class="ca-tenue">{{ d.fila.cuentaNombre }} · {{ d.fila.cuentaDetalle }}</div>
            </div>
            <div class="ca-detalle-der">
              <span class="ca-badge" [ngClass]="estados[d.fila.estado].clase">{{ estados[d.fila.estado].etiqueta }}</span>
              <button type="button" class="ca-cerrar" aria-label="Cerrar detalle" (click)="cerrarDetalle()">×</button>
            </div>
          </div>

          <div class="ca-detalle-datos">
            <div><span class="ca-tenue">Depositó</span><b>{{ d.fila.nombre || '—' }}</b><span class="ca-tenue">{{ d.fila.documento }}</span></div>
            <div><span class="ca-tenue">Referencia</span><b class="ca-mono">{{ d.fila.referencia || '—' }}</b><span class="ca-tenue">{{ d.fila.fechaBanco }} {{ d.fila.horaBanco }}</span></div>
          </div>

          <div>
            <h3 class="ca-detalle-sub">Recorrido</h3>
            <ol class="ca-pasos">
              <li *ngFor="let p of d.pasos; let ultimo = last" class="ca-paso">
                <span class="ca-paso-linea">
                  <span class="ca-paso-ico" [ngClass]="'p-' + p.estado" [attr.aria-label]="p.estado === 'ok' ? 'Listo' : p.estado === 'pendiente' ? 'Trabado' : 'Pendiente'">{{ p.estado === 'ok' ? '✓' : p.estado === 'pendiente' ? '!' : '–' }}</span>
                  <span class="ca-paso-raya" *ngIf="!ultimo"></span>
                </span>
                <span class="ca-paso-txt"><b>{{ p.titulo }}</b><span>{{ p.detalle }}</span></span>
              </li>
            </ol>
          </div>

          <div class="ca-detalle-pie" *ngIf="d.fila.cliente as c">
            <span class="ca-asignado-quien">
              <span class="ca-av">{{ iniciales(c.nombre) }}</span>
              <span class="ca-asignado-txt"><b>{{ c.nombre }}</b><span class="ca-tenue">ID {{ c.usuarioId }}<ng-container *ngIf="c.email"> · {{ c.email }}</ng-container></span></span>
            </span>
            <button type="button" class="ca-btn ca-btn-o" (click)="verMovimientos(d.fila)" [disabled]="!c.email">Ver movimientos del cliente</button>
          </div>

          <div class="ca-detalle-motivo" *ngIf="d.motivo">
            <p>{{ d.motivo }}</p>
            <p class="ca-detalle-accion" *ngIf="d.accion">{{ d.accion }}</p>
            <button type="button" class="ca-btn ca-btn-p ca-btn-ancho" *ngIf="accion(d.fila) as a" (click)="irA(a.ruta)">{{ a.etiqueta }}</button>
          </div>
        </ng-container>
      </aside>
    </section>

    <p class="ca-nota">
      Solo lectura: esta pantalla no asigna ni acredita. Los botones llevan a la pantalla donde se resuelve cada caso.
      <ng-container *ngIf="pais === 'CL' && corteHistorico">
        Las cartolas asignadas antes del {{ corteHistorico }} se dan por acreditadas: hasta entonces el abono no quedaba enlazado a su cartola.
      </ng-container>
      <ng-container *ngIf="pais === 'USDT'">
        Binance Link solo registra depósitos de sub-cuentas activas con KYC aprobado: los de una sub-cuenta sin KYC no aparecen acá.
      </ng-container>
    </p>
  </div>
</div>
